/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';

  
    const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "542")
  

// 接口文档



export interface API76170Req {
  
  /** 任务节点id */
  bizNo?: string;
};



export type API76170Res = {};


// 接口函数 76170 删除任务节点

export interface IUsePostAPI76170Return {
  /** 删除任务节点: 接口请求状态 */
  isAPI76170Loading: boolean;
  /** 删除任务节点: 接口请求返回数据 */
  dataAPI76170: API76170Res;
  /**  删除任务节点: 接口数据请求方法 */
  fetchAPI76170Data: (inputs: API76170Req, config?: YWRequestConfig) => Promise<API76170Res>;
  /** 删除任务节点: 接口请求URL */
  requestUrl: string;
}

export const usePostAPI76170 = ():IUsePostAPI76170Return => {
  let isMount = true;
  const [isAPI76170Loading, setIsAPI76170Loading] = useState(false);
  const [dataAPI76170, setDataAPI76170] = useState<API76170Res>({} as API76170Res);
  const requestUrl = `${basePath}/yoaichat-web/task/instance/delete/node`;

  const fetchAPI76170Data = async (inputs: API76170Req, config?: YWRequestConfig): Promise<API76170Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API76170Req>) || {}) as API76170Req;
    
  
    if ( isMount ) {
      setIsAPI76170Loading(true);
    }

    try {
      
      
      
      const res: any = await Request.post<API76170Res>(`${basePath}/yoaichat-web/task/instance/delete/node`, params, {
        loginHost: loginPath,
        ...config
      });
      
      
      if (isMount) {
        setDataAPI76170(res || {} as API76170Res);
        setIsAPI76170Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI76170Loading(false);
      }
      return false as unknown as API76170Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI76170Loading,
    dataAPI76170,
    fetchAPI76170Data,
    requestUrl,
  }
}

